export default __webpack_public_path__ + "static/media/full_arrow_right.325d082f.svg";